module.exports = __webpack_public_path__ + "img/threat-analytics-users.dde2f1c4.png";